import "./TopRibbon.css";

/**
 * Corner ribbon for top-ranked venues/vendors. Renders in the top-right of the parent (position relative).
 * @param {{ label: string }} props - label: "Top Venues" | "Top Vendors"
 */
function TopRibbon({ label = "Top" }) {
  return (
    <div className="top-ribbon-wrap" aria-hidden>
      <div className="top-ribbon">
        <span className="top-ribbon-fold top-ribbon-fold--left" />
        <span className="top-ribbon-text">{label}</span>
        <span className="top-ribbon-fold top-ribbon-fold--right" />
      </div>
    </div>
  );
}

export default TopRibbon;
